{
  "files": {
    "us": {
      "filename": "nonemp23us.zip",
      "url": "https://www2.census.gov/programs-surveys/nonemployer-statistics/datasets/2023/historical-datasets/nonemp23us.zip",
      "sha256": "420e37afbf7c05f3cd399316e59f21df9022efc0fcde8c965354c920f9329576"
    },
    "st": {
      "filename": "nonemp23st.zip",
      "url": "https://www2.census.gov/programs-surveys/nonemployer-statistics/datasets/2023/historical-datasets/nonemp23st.zip",
      "sha256": "2e75357e5ee8fe73ad83ba66bb6212df9e93e1b4edadda60425f7ff26c5741b7"
    }
  },
  "publicationDate": "2025-05-15",
  "year": 2023,
  "national": [
    {
      "state": "00",
      "naics": "00",
      "businesses": 30427808,
      "receiptsThousands": 1752978019,
      "noiseFlag": "G"
    },
    {
      "state": "00",
      "naics": "54",
      "businesses": 4075717,
      "receiptsThousands": 234267272,
      "noiseFlag": "G"
    },
    {
      "state": "00",
      "naics": "5411",
      "businesses": 274000,
      "receiptsThousands": 23165331,
      "noiseFlag": "G"
    },
    {
      "state": "00",
      "naics": "5412",
      "businesses": 396812,
      "receiptsThousands": 13702563,
      "noiseFlag": "G"
    },
    {
      "state": "00",
      "naics": "5414",
      "businesses": 277731,
      "receiptsThousands": 12799771,
      "noiseFlag": "G"
    },
    {
      "state": "00",
      "naics": "5415",
      "businesses": 343329,
      "receiptsThousands": 20589836,
      "noiseFlag": "G"
    },
    {
      "state": "00",
      "naics": "5416",
      "businesses": 1081961,
      "receiptsThousands": 64739993,
      "noiseFlag": "G"
    },
    {
      "state": "00",
      "naics": "5417",
      "businesses": 58029,
      "receiptsThousands": 2150156,
      "noiseFlag": "G"
    },
    {
      "state": "00",
      "naics": "5418",
      "businesses": 207863,
      "receiptsThousands": 12644434,
      "noiseFlag": "G"
    },
    {
      "state": "00",
      "naics": "54191",
      "businesses": 40138,
      "receiptsThousands": 1781173,
      "noiseFlag": "G"
    },
    {
      "state": "00",
      "naics": "54192",
      "businesses": 236666,
      "receiptsThousands": 6823388,
      "noiseFlag": "G"
    },
    {
      "state": "00",
      "naics": "54193",
      "businesses": 54203,
      "receiptsThousands": 1442073,
      "noiseFlag": "G"
    }
  ],
  "states": [
    {
      "state": "01",
      "naics": "54",
      "businesses": 40531,
      "receiptsThousands": 1911863,
      "noiseFlag": "G"
    },
    {
      "state": "02",
      "naics": "54",
      "businesses": 7362,
      "receiptsThousands": 355901,
      "noiseFlag": "G"
    },
    {
      "state": "04",
      "naics": "54",
      "businesses": 84142,
      "receiptsThousands": 4881806,
      "noiseFlag": "G"
    },
    {
      "state": "05",
      "naics": "54",
      "businesses": 22854,
      "receiptsThousands": 966963,
      "noiseFlag": "G"
    },
    {
      "state": "06",
      "naics": "54",
      "businesses": 577881,
      "receiptsThousands": 36092248,
      "noiseFlag": "G"
    },
    {
      "state": "08",
      "naics": "54",
      "businesses": 101710,
      "receiptsThousands": 5516455,
      "noiseFlag": "G"
    },
    {
      "state": "09",
      "naics": "54",
      "businesses": 50817,
      "receiptsThousands": 3565356,
      "noiseFlag": "G"
    },
    {
      "state": "10",
      "naics": "54",
      "businesses": 14450,
      "receiptsThousands": 1807857,
      "noiseFlag": "G"
    },
    {
      "state": "11",
      "naics": "54",
      "businesses": 17782,
      "receiptsThousands": 1412065,
      "noiseFlag": "G"
    },
    {
      "state": "12",
      "naics": "54",
      "businesses": 364863,
      "receiptsThousands": 23177197,
      "noiseFlag": "G"
    },
    {
      "state": "13",
      "naics": "54",
      "businesses": 136618,
      "receiptsThousands": 6779615,
      "noiseFlag": "G"
    },
    {
      "state": "15",
      "naics": "54",
      "businesses": 16752,
      "receiptsThousands": 917077,
      "noiseFlag": "G"
    },
    {
      "state": "16",
      "naics": "54",
      "businesses": 22690,
      "receiptsThousands": 1024182,
      "noiseFlag": "G"
    },
    {
      "state": "17",
      "naics": "54",
      "businesses": 140212,
      "receiptsThousands": 7460755,
      "noiseFlag": "G"
    },
    {
      "state": "18",
      "naics": "54",
      "businesses": 53832,
      "receiptsThousands": 2369677,
      "noiseFlag": "G"
    },
    {
      "state": "19",
      "naics": "54",
      "businesses": 23376,
      "receiptsThousands": 946312,
      "noiseFlag": "G"
    },
    {
      "state": "20",
      "naics": "54",
      "businesses": 27297,
      "receiptsThousands": 1286764,
      "noiseFlag": "G"
    },
    {
      "state": "21",
      "naics": "54",
      "businesses": 33784,
      "receiptsThousands": 1592320,
      "noiseFlag": "G"
    },
    {
      "state": "22",
      "naics": "54",
      "businesses": 43950,
      "receiptsThousands": 2101915,
      "noiseFlag": "G"
    },
    {
      "state": "23",
      "naics": "54",
      "businesses": 16257,
      "receiptsThousands": 759410,
      "noiseFlag": "G"
    },
    {
      "state": "24",
      "naics": "54",
      "businesses": 88868,
      "receiptsThousands": 4964304,
      "noiseFlag": "G"
    },
    {
      "state": "25",
      "naics": "54",
      "businesses": 108626,
      "receiptsThousands": 6924811,
      "noiseFlag": "G"
    },
    {
      "state": "26",
      "naics": "54",
      "businesses": 97945,
      "receiptsThousands": 4757496,
      "noiseFlag": "G"
    },
    {
      "state": "27",
      "naics": "54",
      "businesses": 64813,
      "receiptsThousands": 2990003,
      "noiseFlag": "G"
    },
    {
      "state": "28",
      "naics": "54",
      "businesses": 21832,
      "receiptsThousands": 945957,
      "noiseFlag": "G"
    },
    {
      "state": "29",
      "naics": "54",
      "businesses": 53867,
      "receiptsThousands": 2487582,
      "noiseFlag": "G"
    },
    {
      "state": "30",
      "naics": "54",
      "businesses": 14216,
      "receiptsThousands": 670446,
      "noiseFlag": "G"
    },
    {
      "state": "31",
      "naics": "54",
      "businesses": 16182,
      "receiptsThousands": 612947,
      "noiseFlag": "G"
    },
    {
      "state": "32",
      "naics": "54",
      "businesses": 41196,
      "receiptsThousands": 3093366,
      "noiseFlag": "G"
    },
    {
      "state": "33",
      "naics": "54",
      "businesses": 19484,
      "receiptsThousands": 1283707,
      "noiseFlag": "G"
    },
    {
      "state": "34",
      "naics": "54",
      "businesses": 136295,
      "receiptsThousands": 9405390,
      "noiseFlag": "G"
    },
    {
      "state": "35",
      "naics": "54",
      "businesses": 18148,
      "receiptsThousands": 855190,
      "noiseFlag": "G"
    },
    {
      "state": "36",
      "naics": "54",
      "businesses": 297385,
      "receiptsThousands": 19963531,
      "noiseFlag": "G"
    },
    {
      "state": "37",
      "naics": "54",
      "businesses": 113585,
      "receiptsThousands": 5259092,
      "noiseFlag": "G"
    },
    {
      "state": "38",
      "naics": "54",
      "businesses": 6049,
      "receiptsThousands": 263725,
      "noiseFlag": "G"
    },
    {
      "state": "39",
      "naics": "54",
      "businesses": 110077,
      "receiptsThousands": 5402576,
      "noiseFlag": "G"
    },
    {
      "state": "40",
      "naics": "54",
      "businesses": 35807,
      "receiptsThousands": 1729065,
      "noiseFlag": "G"
    },
    {
      "state": "41",
      "naics": "54",
      "businesses": 53702,
      "receiptsThousands": 2538790,
      "noiseFlag": "G"
    },
    {
      "state": "42",
      "naics": "54",
      "businesses": 132445,
      "receiptsThousands": 7250427,
      "noiseFlag": "G"
    },
    {
      "state": "44",
      "naics": "54",
      "businesses": 13895,
      "receiptsThousands": 718142,
      "noiseFlag": "G"
    },
    {
      "state": "45",
      "naics": "54",
      "businesses": 52780,
      "receiptsThousands": 2517201,
      "noiseFlag": "G"
    },
    {
      "state": "46",
      "naics": "54",
      "businesses": 8146,
      "receiptsThousands": 339242,
      "noiseFlag": "G"
    },
    {
      "state": "47",
      "naics": "54",
      "businesses": 74480,
      "receiptsThousands": 4239963,
      "noiseFlag": "G"
    },
    {
      "state": "48",
      "naics": "54",
      "businesses": 361655,
      "receiptsThousands": 21381985,
      "noiseFlag": "G"
    },
    {
      "state": "49",
      "naics": "54",
      "businesses": 52384,
      "receiptsThousands": 2855852,
      "noiseFlag": "G"
    },
    {
      "state": "50",
      "naics": "54",
      "businesses": 9956,
      "receiptsThousands": 492726,
      "noiseFlag": "G"
    },
    {
      "state": "51",
      "naics": "54",
      "businesses": 110345,
      "receiptsThousands": 6616158,
      "noiseFlag": "G"
    },
    {
      "state": "53",
      "naics": "54",
      "businesses": 93524,
      "receiptsThousands": 4970512,
      "noiseFlag": "G"
    },
    {
      "state": "54",
      "naics": "54",
      "businesses": 10285,
      "receiptsThousands": 453580,
      "noiseFlag": "G"
    },
    {
      "state": "55",
      "naics": "54",
      "businesses": 50667,
      "receiptsThousands": 2326921,
      "noiseFlag": "G"
    },
    {
      "state": "56",
      "naics": "54",
      "businesses": 9918,
      "receiptsThousands": 1030847,
      "noiseFlag": "G"
    }
  ]
}
